<template>
    <div class="max-w-2xl mx-auto p-4">
        <h1 class="text-2xl font-semibold text-theme-base mb-6">
            Tipos de producto
        </h1>

        <p class="text-sm text-theme-muted mb-4">
            Selecciona los tipos de producto que tu negocio maneja. Solo estos
            tipos estarán disponibles al crear o editar productos. Cada tipo
            define cómo se gestionan las variantes.
        </p>

        <div class="flex flex-col gap-6">
            <div class="bg-theme-card rounded-xl p-6 flex flex-col gap-4">
                <section>
                    <product-type-selector
                        v-model="form.allowedProductTypes"
                        :options="allProductTypeOptions"
                    />

                    <p
                        v-if="
                            validationTouched &&
                            !form.allowedProductTypes.length
                        "
                        class="text-theme-danger text-sm mt-3"
                    >
                        Selecciona al menos un tipo de producto
                    </p>
                </section>
            </div>

            <div class="rounded-xl p-6 flex justify-center">
                <app-button size="large" :loading="isLoading" @click="save">
                    Actualizar
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import {
    ALL_PRODUCT_TYPE_OPTIONS,
    PRODUCT_VARIANTS_PERMISSION,
    typeRequiresVariants
} from "@/common/fields/product-types";

import ProductTypeSelector from "@/components/tenants/ProductTypeSelector.vue";

export default {
    name: "ProductTypesSettingsPage",
    components: { ProductTypeSelector },
    layout: "app",
    data: () => ({
        isLoading: false,
        validationTouched: false,
        allProductTypeOptions: ALL_PRODUCT_TYPE_OPTIONS,
        form: {
            allowedProductTypes: []
        }
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("tenant:GetProductTypes", "/app")))
            return;
        await this.loadSettings();
    },
    methods: {
        ...mapActions("tenants", [
            "getTenantProductTypes",
            "updateTenantProductTypes"
        ]),
        // pedidos-whatsapp: sin la feature de variantes backend solo acepta
        // `single` (el default de todos los tenants trae `article`).
        onlyAllowedTypes(types) {
            if (this.$ability.hasPermission(PRODUCT_VARIANTS_PERMISSION)) {
                return [...types];
            }
            return types.filter((type) => !typeRequiresVariants(type));
        },
        async loadSettings() {
            this.$loading.show();
            try {
                const data = await this.getTenantProductTypes();
                this.form.allowedProductTypes = this.onlyAllowedTypes(
                    Array.isArray(data.allowedProductTypes)
                        ? data.allowedProductTypes
                        : []
                );
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async save() {
            this.validationTouched = true;
            if (!this.form.allowedProductTypes.length) return;

            this.isLoading = true;
            try {
                const allowedProductTypes = this.onlyAllowedTypes(
                    this.form.allowedProductTypes
                );
                await this.updateTenantProductTypes({
                    allowedProductTypes: allowedProductTypes.length
                        ? allowedProductTypes
                        : ["single"]
                });
                this.$toast.success({
                    title: "Configuración actualizada",
                    text: "Los datos del catálogo han sido guardados."
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
